/* eslint-disable no-bitwise */
import { isColorNameMappedToHex, nameToHex } from './nameToHex';

/*
 * Darkens a given color to create its hover color.
 *
 * Color conversion logic adapted from:
 * https://jonlabelle.com/snippets/view/javascript/lighten-and-darken-colors-in-javascript
 */
const getHoverColor = (color: Parameters<typeof nameToHex>[0] | string) => {
  // Use hex value
  let hex = isColorNameMappedToHex(color) ? nameToHex(color) : color;

  // Remove the pound
  hex = hex.slice(1);

  // If this is a 3 char hex code, make it a 6 char hex
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  // Convert to integer
  const int = parseInt(hex, 16);

  // The amount to darken by
  const amount = -51;

  // Ensures a number falls between 0 - 255
  const constrain = (value: number) => Math.min(Math.max(value, 0), 255);

  // Modify each color channel separately
  const red = constrain((int >> 16) + amount);
  const green = constrain(((int >> 8) & 0x00ff) + amount);
  const blue = constrain((int & 0x0000ff) + amount);

  // Convert the modified color chanel back to its hex value
  const rHex = (red << 16).toString(16).padStart(6, '0').slice(0, 2);

  const bHex = (blue << 8).toString(16).padStart(4, '0').slice(0, 2);

  const gHex = green.toString(16).padStart(2, '0').slice(0, 2);

  // Parse channels back together as a hex
  const result = `#${rHex}${gHex}${bHex}`;

  return result;
};

export default getHoverColor;
